import React, { useCallback } from 'react';
import config from '../../config';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { clearCollege, flipView, selectCollege, selectCollegeYear, selectGradYear, selectStudentType, selectUserType, setEmailError } from '../../store/reducer';
import Header from '../Header';
import Selection from '../Selection';
import { FlipViewButton, Footer, Link, SubmitButton } from '../shared.styles';
import Social from '../Social';
import TermsAndPromos from '../TermsAndPromos';
import Credentials from './Credentials';
import SsoCredentials from './SsoCredentials/SsoCredentials';
import { CollegeDropDown } from './Signup.styles';
import validateSignup from './validateSignup';
import { interactionsRioEvent } from '../../lib/rio/rioEvents';
import { StudentType, UserType } from '@chegg/one-auth-sdk';
import { sdkSignup } from '../../store/reducers/sdkSignup';
import { PxCaptchaTypes, View } from '../../store/types';
import { setGenericError, setLoading } from '../../store/sharedActions';
import { useSendStartEvents } from '../hooks/useSendStartEvents';
import PxCaptcha from '../PxCaptcha';
import { getTexts } from '../../lib/contentful/defaultTexts';
var Signup = function Signup(props) {
  var _options$form;
  var options = props.options,
    styles = props.styles;
  var dispatch = useAppDispatch();
  var env = useAppSelector(function (state) {
    return state.env;
  });
  var state = useAppSelector(function (state) {
    return state.signup;
  });
  var isGdpr = useAppSelector(function (state) {
    return state.isGdpr;
  });
  var isSso = useAppSelector(function (state) {
    return state.signup.isSso;
  });
  var showBack = useAppSelector(function (state) {
    return state.showBack;
  });
  var backView = useAppSelector(function (state) {
    return state.backView;
  });
  var frontView = useAppSelector(function (state) {
    return state.frontView;
  });
  var email = useAppSelector(function (state) {
    return state.signup.credentials.email;
  });
  var view = showBack && backView || frontView;
  var pxCaptchaType = useAppSelector(function (state) {
    return state.pxCaptchaType;
  });
  var showUserInfo = state.showUserInfo,
    gdpr = state.gdpr,
    loading = state.loading;
  var onBoardingComplete = validateSignup(state, options);
  var isValid = isGdpr ? onBoardingComplete && gdpr.termsOfUse : onBoardingComplete;
  var _getTexts = getTexts(),
    _getTexts$signup = _getTexts.signup,
    title = _getTexts$signup.title,
    buttonTitle = _getTexts$signup.buttonTitle,
    identityTitle = _getTexts$signup.identityTitle,
    schoolTypeTitle = _getTexts$signup.schoolTypeTitle,
    highSchoolYearSelectTitle = _getTexts$signup.highSchoolYearSelectTitle,
    collegeSelectTitle = _getTexts$signup.collegeSelectTitle,
    collegeNamePlaceHolder = _getTexts$signup.collegeNamePlaceHolder,
    collegeYearSelectionTitle = _getTexts$signup.collegeYearSelectionTitle,
    invalidEmailError = _getTexts$signup.invalidEmailError,
    emptyEmailError = _getTexts$signup.emptyEmailError,
    agreeToTermsAndPrivacyText = _getTexts$signup.agreeToTermsAndPrivacyText,
    legalTermsLinkText = _getTexts$signup.legalTermsLinkText,
    andText = _getTexts$signup.andText,
    privacyPolicyLinkText = _getTexts$signup.privacyPolicyLinkText,
    bottomFooterText = _getTexts$signup.bottomFooterText,
    flipToSigninButtonText = _getTexts$signup.flipToSigninButtonText,
    student = _getTexts$signup.student,
    parent = _getTexts$signup.parent,
    highschool = _getTexts$signup.highschool,
    college = _getTexts$signup.college,
    schoolsDropdownManualInputLabel = _getTexts$signup.schoolsDropdownManualInputLabel,
    schoolNotListedText = _getTexts$signup.schoolNotListedText,
    schoolNotFoundSelectedValue = _getTexts$signup.schoolNotFoundSelectedValue,
    schoolManualInputPlaceholder = _getTexts$signup.schoolManualInputPlaceholder;
  useSendStartEvents(View.SIGNUP);
  var onIdentitySelect = useCallback(function (index, items) {
    dispatch(selectUserType({
      index: index,
      userType: items[index]
    }));
    if (index !== state.userInfo.selectedUserTypeIndex) {
      interactionsRioEvent({
        interaction: {
          type: 'select',
          element: {
            type: 'button',
            name: 'member role',
            region_name: 'sign up auth page',
            value: items[index]
          }
        }
      });
    }
  }, [dispatch, state.userInfo.selectedUserTypeIndex]);
  var onSchoolTypeSelect = useCallback(function (index, items) {
    dispatch(selectStudentType({
      index: index,
      studentType: items[index]
    }));
    if (index !== state.userInfo.student.selectedIndex) {
      interactionsRioEvent({
        interaction: {
          type: 'select',
          element: {
            type: 'button',
            name: 'high school or college',
            region_name: 'sign up auth page',
            value: items[index]
          }
        }
      });
    }
  }, [dispatch, state.userInfo.student.selectedIndex]);
  var onHighSchoolYearSelect = useCallback(function (index) {
    dispatch(selectGradYear({
      index: index
    }));
    if (index !== state.userInfo.student.highschool.selectedIndex) {
      interactionsRioEvent({
        interaction: {
          type: 'select',
          element: {
            type: 'button',
            name: 'high school graduation year',
            region_name: 'sign up auth page',
            value: state.userInfo.student.highschool.years[index].text
          }
        }
      });
    }
  }, [dispatch, state.userInfo.student.highschool.years, state.userInfo.student.highschool.selectedIndex]);
  var onCollegeSelect = useCallback(function (school) {
    dispatch(selectCollege({
      campusId: school.uuid,
      name: school.value
    }));
    interactionsRioEvent({
      interaction: {
        type: 'select',
        element: {
          type: 'drop down',
          name: 'school name',
          region_name: 'sign up auth page',
          value: school.value
        }
      }
    });
  }, [dispatch]);
  var onManualInputCollegeChange = useCallback(function (name, campusId) {
    dispatch(selectCollege({
      campusId: campusId,
      name: name
    }));
  }, [dispatch]);
  var onCollegeInputChange = useCallback(function (value) {
    if (value) return;
    dispatch(clearCollege());
  }, [dispatch]);
  var onCollegeYearSelect = useCallback(function (index) {
    dispatch(selectCollegeYear({
      index: index
    }));
    if (index !== state.userInfo.student.college.selectedIndex) {
      interactionsRioEvent({
        interaction: {
          type: 'select',
          element: {
            type: 'button',
            name: 'year in school',
            region_name: 'sign up auth page',
            value: "".concat(index + 1)
          }
        }
      });
    }
  }, [dispatch, state.userInfo.student.college.selectedIndex]);
  return /*#__PURE__*/React.createElement("div", {
    "data-test": "signup_view"
  }, /*#__PURE__*/React.createElement(Header, {
    "data-test": "signup_",
    styles: styles === null || styles === void 0 ? void 0 : styles.header,
    subTitle: (options === null || options === void 0 ? void 0 : options.subtitle) || '',
    title: (options === null || options === void 0 ? void 0 : options.title) || title
  }), /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit,
    autoComplete: "off"
  }, renderCredentials(), renderIdentity(), renderTermsAndPromos(), renderPxCaptcha(), renderSocialButtons(), /*#__PURE__*/React.createElement(SubmitButton, {
    type: "submit",
    size: "medium",
    disabled: options !== null && options !== void 0 && (_options$form = options.form) !== null && _options$form !== void 0 && _options$form.userInfo ? !isValid : false,
    isLoading: loading,
    "data-test": "signup_submit_button",
    className: "signup_submit"
  }, (options === null || options === void 0 ? void 0 : options.buttonTitle) || buttonTitle), renderLegal()));
  function renderIdentity() {
    var _options$form2;
    if (!(options !== null && options !== void 0 && (_options$form2 = options.form) !== null && _options$form2 !== void 0 && _options$form2.userInfo) || !showUserInfo) return null;
    var items = Object.keys(options.form.userInfo);
    var selectionItems = items.map(function (key) {
      return {
        text: key === UserType.student ? student : parent
      };
    });
    var selectedUserTypeIndex = state.userInfo.selectedUserTypeIndex;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Selection, {
      items: selectionItems,
      dataTest: "identity",
      title: identityTitle,
      onItemClick: function onItemClick(index) {
        return onIdentitySelect(index, items);
      },
      selectedIndex: selectedUserTypeIndex
    }), renderSchoolSelection());
  }
  function renderSchoolSelection() {
    if (!state.userInfo.userType) return null; // user didnt choose userType yet

    var items = Object.keys(options.form.userInfo[state.userInfo.userType]);
    if (!items.length) return null; // user type is not configured with any module (endflow)

    var selectionItems = items.map(function (key) {
      return {
        text: key === StudentType.highschool ? highschool : college
      };
    });
    var _state$userInfo$stude = state.userInfo.student,
      selectedIndex = _state$userInfo$stude.selectedIndex,
      studentType = _state$userInfo$stude.studentType;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Selection, {
      items: selectionItems,
      dataTest: "student_type_selection",
      title: schoolTypeTitle,
      onItemClick: function onItemClick(index) {
        return onSchoolTypeSelect(index, items);
      },
      selectedIndex: selectedIndex
    }), studentType === StudentType.highschool && renderHighschoolGradYear(), studentType === StudentType.college && renderCollegeSelection());
  }
  function renderCredentials() {
    if (isSso) {
      return /*#__PURE__*/React.createElement(SsoCredentials, null);
    }
    return /*#__PURE__*/React.createElement(Credentials, null);
  }
  function renderHighschoolGradYear() {
    if (!options.form.userInfo[state.userInfo.userType].highschool.highschoolGradYearSelect) {
      return null;
    }
    var student = state.userInfo.student;
    var _student$highschool = student.highschool,
      selectedIndex = _student$highschool.selectedIndex,
      years = _student$highschool.years;
    return /*#__PURE__*/React.createElement(Selection, {
      items: years,
      dataTest: "highschool_grad_selection",
      title: highSchoolYearSelectTitle,
      onItemClick: onHighSchoolYearSelect,
      selectedIndex: selectedIndex
    });
  }
  function renderCollegeSelection() {
    if (!options.form.userInfo[state.userInfo.userType].college.collegeSelect) {
      return null;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CollegeDropDown, {
      className: "college_dropdown_container",
      "data-test": "college_dropdown",
      inputId: "college_dropdown",
      labelText: collegeSelectTitle,
      onSelect: onCollegeSelect,
      onInputChange: onCollegeInputChange,
      manualInput: {
        labelText: schoolsDropdownManualInputLabel,
        onChange: onManualInputCollegeChange,
        placeholder: schoolManualInputPlaceholder
      },
      width: "100%",
      placeholder: collegeNamePlaceHolder,
      defaultValue: state.userInfo.student.college.name,
      schoolNotFoundSelectedValue: schoolNotFoundSelectedValue,
      schoolNotListedText: schoolNotListedText
    }), renderCollegeYears());
  }
  function renderCollegeYears() {
    var _collegeSelect;
    if (!((_collegeSelect = options.form.userInfo[state.userInfo.userType].college.collegeSelect) !== null && _collegeSelect !== void 0 && _collegeSelect.yearInSchool)) {
      return null;
    }
    if (!state.userInfo.student.college.isCollegeSelected) return null;
    if (!state.userInfo.student.college.campusId) return null;
    var _state$userInfo$stude2 = state.userInfo.student.college,
      selectedIndex = _state$userInfo$stude2.selectedIndex,
      years = _state$userInfo$stude2.years;
    return /*#__PURE__*/React.createElement(Selection, {
      items: years,
      dataTest: "college_year_selection",
      title: collegeYearSelectionTitle,
      onItemClick: onCollegeYearSelect,
      selectedIndex: selectedIndex
    });
  }
  function onSubmit(e) {
    e.preventDefault();
    if (!isSso && !email.valid && !email.error) {
      dispatch(setEmailError({
        error: email.value && invalidEmailError || emptyEmailError
      }));
      return;
    }
    if (!loading && isValid) {
      dispatch(sdkSignup());
      interactionsRioEvent({
        interaction: {
          type: 'click',
          element: {
            type: 'button',
            name: 'create account',
            region_name: 'sign up auth page'
          }
        }
      });
    }
  }
  function renderLegal() {
    var tos = options !== null && options !== void 0 && options.termsOfUse ? options === null || options === void 0 ? void 0 : options.termsOfUse : config[env].termsOfUseLink;
    var pp = config[env].privacyPolicyLink;
    return /*#__PURE__*/React.createElement(Footer, null, !isGdpr && /*#__PURE__*/React.createElement("p", null, agreeToTermsAndPrivacyText, ' ', /*#__PURE__*/React.createElement(Link, {
      href: tos,
      target: "_blank",
      "data-test": "legal_terms_link"
    }, legalTermsLinkText), ' ', andText, ' ', /*#__PURE__*/React.createElement(Link, {
      href: pp,
      target: "_blank",
      "data-test": "legal_privacy_link"
    }, privacyPolicyLinkText)), /*#__PURE__*/React.createElement("p", {
      "data-test": "bottom_footer_text"
    }, bottomFooterText, ' ', /*#__PURE__*/React.createElement(FlipViewButton, {
      "data-test": "flip_to_signin",
      onClick: onClickFlipButton
    }, flipToSigninButtonText)));
  }
  function renderSocialButtons() {
    var _options$form3, _options$form3$creden;
    return /*#__PURE__*/React.createElement(Social, {
      providers: (options === null || options === void 0 ? void 0 : (_options$form3 = options.form) === null || _options$form3 === void 0 ? void 0 : (_options$form3$creden = _options$form3.credentials) === null || _options$form3$creden === void 0 ? void 0 : _options$form3$creden.ssoProviders) || ['apple', 'facebook', 'google']
    });
  }
  function renderTermsAndPromos() {
    if (!isGdpr || !onBoardingComplete) return null;
    return /*#__PURE__*/React.createElement(TermsAndPromos, {
      termsOfUse: options === null || options === void 0 ? void 0 : options.termsOfUse
    });
  }
  function onClickFlipButton() {
    interactionsRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'link',
          name: 'flip to sign in page',
          region_name: 'bottom of modal'
        }
      }
    });
    dispatch(flipView({
      view: View.SIGNIN
    }));
    if (pxCaptchaType === PxCaptchaTypes.SIGNUP) {
      dispatch(setGenericError({
        error: '',
        onView: View.SIGNUP
      }));
      dispatch(setLoading({
        loading: false,
        onView: View.SIGNUP
      }));
    }
  }
  function renderPxCaptcha() {
    if (pxCaptchaType !== PxCaptchaTypes.SIGNUP || view !== View.SIGNUP) return null;
    return /*#__PURE__*/React.createElement(PxCaptcha, {
      dataTest: "px_captcha_signup"
    });
  }
};
export default Signup;